import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { geneAsyncAction } from 'services/actionConfigs';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { featureName } from './constants';
import { ICashDeposit, IPaymentType, ISummary, ISummaryChart, TimeFilter } from './types';


interface IHomeReducerState {
  summary: ISummary | null
  cashDeposit: ICashDeposit | null
  summaryChart: ISummaryChart[] | null
  paymentType: IPaymentType[] | null
}

type MyState = IHomeReducerState;

// Types
type SliceState = {
  summary: MyState['summary']
  summaryChart: MyState['summaryChart']
  cashDeposit: MyState['cashDeposit']
  paymentType: MyState['paymentType']
};



// Actions
const createAsync = geneAsyncAction(featureName);
const api = {
  report: {
    getSummary: createAsync<{ endDate: string, startDate: string }>('summary'),
    getSummaryChart: createAsync<{type: TimeFilter}>('summaryChart'),
    getPaymentType: createAsync<{ endDate: string, startDate: string }>('paymentType'),
    getCashDeposit : createAsync<{endDate: string, startDate: string}>('cashDeposit')
  },
};



const getCurrentState = (state: RootState) => state['home']; 

const selector = <T>(key: keyof T, defaultValue?: any) => useAppSelector((state) => get(getCurrentState(state), key, defaultValue));

const selectors = {
  summaryChart: () => selector('summaryChart') as MyState['summaryChart'],
  summary: () => selector('summary') as MyState['summary'],
  paymentType: () => selector('paymentType') as MyState['paymentType'],
  cashDeposit: () => selector('cashDeposit') as MyState['cashDeposit'],
};


// Slice
const slice = createSlice({
  name: featureName,
  initialState: {
    summary: null,
    cashDeposit: null,
    summaryChart: null,
    paymentType: null
  } as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    // tables Settings
    builder
      .addCase(api.report.getCashDeposit.success, (state, { payload }) => {
        state.cashDeposit = payload;
      })
      .addCase(api.report.getSummary.success, (state, { payload }) => {
        state.summary = payload;
      })
      .addCase(api.report.getSummaryChart.success, (state, { payload }) => {
        state.summaryChart = payload;
      })
      .addCase(api.report.getPaymentType.success, (state, { payload }) => {
        state.paymentType = payload;
      });
  },
});

export const actions = { ...slice.actions, api, selectors };
export const reducer = slice.reducer;
